import { useEffect, useState } from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { Box, Checkbox, Drawer, FormControlLabel, Stack, Typography } from "@mui/material";
import { EGInput } from "../../../../../MainComponents/Input/EGInput";
import { InvestigationButton } from "../../components/InvestigationButton";
import { DrawerContainer } from "../../components/DrawerContainer";

// Drawer en la parte de RECURSOS HUMANOS
export const Roles = ({
  resource, 
  roles,
  showRoles, 
  setShowRoles, 
  handleChange,
}) => {

  const [t] = useTranslation("investigation");

  const [selectedRoles, setSelectedRoles] = useState(Array.isArray(resource?.roles) ? resource.roles : []);
  const [otherActivities, setOtherActivities] = useState(resource?.other_activities ?? "");

  useEffect(() => {
    if (!showRoles) {
      setSelectedRoles([]);
      setOtherActivities("");
    } else {
      setSelectedRoles(Array.isArray(resource?.roles) ? resource.roles : []);
      setOtherActivities(resource?.other_activities ?? "");
    }
  }, [showRoles]);

  const handleSelectedRoles = (evt) => {
    const { name, checked } = evt.target;
    if (!checked) {
      setSelectedRoles(selectedRoles.filter(item => item !== name));
    } else {
      setSelectedRoles([...selectedRoles, name]);
    }
  }

  const handleLocalSaveRoles = () => {
    handleChange(null, true, {
      roles: selectedRoles,
      other_activities: selectedRoles.includes("other_research_activities") ? otherActivities : "",
    });
    setShowRoles(false);
  }

  return (
    <DrawerContainer open={showRoles} onClose={() => setShowRoles(false)} borderColor="magentaBliss.main">
      <Box padding="10px 20px 20px 20px">
        <Typography fontSize={28} fontWeight={600} marginBottom={.8} color="magentaBliss.main" >
          {t("resources.investigation_roles")}
        </Typography>
        <Typography marginBottom={1.7} fontSize={16} color="secondary.main">
          {t("resources.add_all_necesary_roles")}:
        </Typography>
        <Stack spacing={1.5} marginBottom={2}>
          {
            Object.entries(roles).map(([key, value]) => (
              <FormControlLabel
                key={key}
                control={
                  <Checkbox 
                    name={key}
                    checked={selectedRoles.includes(key)}
                    onChange={handleSelectedRoles}
                    size="small"
                    sx={{ paddingY: 0 }}
                  />
                } 
                slotProps={{
                  typography: {
                    fontSize: 16,
                    color: 'secondary',
                    fontWeight: 600,
                  }
                }}
                label={value} 
              />
            ))
          }
        </Stack>
        {
          selectedRoles.includes("other_research_activities") && (
            <EGInput
              label={t("resources.other_research_activities")}
              name="other_activities"
              value={otherActivities}
              onChange={(e) => setOtherActivities(e.target.value)}
              type="textarea"
              multiline
              rows={5}
              sx={{ marginBottom: 2 }}
            />
          )
        }
        <Box display="flex" justifyContent="end">
          <InvestigationButton
            label={t("resources.save")}
            variant="success"
            size="medium"
            icon="mark_check_bold"
            onClick={handleLocalSaveRoles}
            sx={{ alignSelf: "end" }}
          />
        </Box>
      </Box>
    </DrawerContainer>
  )
}